import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ScreeningPartyService } from 'src/app/core/services/screening-parties/screening-party.service';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import {
  MeetingType,
  ScreeningParty,
  ScreeningPartyType,
} from 'src/app/core/models/screening-party.model';
import { DomSanitizer } from '@angular/platform-browser';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-first-step',
  templateUrl: './first-step.component.html',
  styleUrls: ['./first-step.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
    DatePipe,
  ],
})
export class FirstStepComponent implements OnInit {
  currentStep = 3;
  datepickerRef;
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  screeningPartyType = ScreeningPartyType;
  screeningPartyTypes = [];
  meetingType = MeetingType;
  meetingTypes = [];
  calendarIconRed = 'calendar-icon-red';
  calendarIconWhite = 'calendar-icon-white';
  filmIcon = 'film-icon';
  partyIconRed = 'party-icon-red';
  partyIconWhite = 'party-icon-white';
  spotlightList = [];
  showcaseList = [];
  movieList = [];
  isInvitation = false;
  invitationScreeningPartyId: number;
  isUpdate: boolean;
  screeningPartyForUpdate: ScreeningParty;
  screeningPartyIdForUpdate: number;

  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  displayProgressSpinner = true;
  spinnerWithoutBackdrop = true;
  @ViewChild(MatHorizontalStepper) stepper: MatHorizontalStepper;

  constructor(
    public datepipe: DatePipe,
    private screeningPartyService: ScreeningPartyService,
    private spotlightService: SpotlightService,
    private showcaseService: ShowcaseService,
    private formBuilder: FormBuilder,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private ngxSpinner: NgxSpinnerService
  ) {
    this.screeningPartyTypes = Object.keys(this.screeningPartyType);
    this.meetingTypes = Object.keys(this.meetingType);
    this.addCustomSVGIcons();
    }

  getCurrentStep(): number {
    try {
      const ln = document.getElementsByClassName(
        'mat-stepper-horizontal-line'
      ) as HTMLCollectionOf<HTMLElement>;

      if (ln.length !== 0) {
        if (this.stepper.selectedIndex === 0) {
          ln[0].setAttribute('style', 'border-top-color: white;');
          ln[1].setAttribute('style', 'border-top-color: white;');
        }
        if (this.stepper.selectedIndex === 1) {
          ln[0].setAttribute('style', 'border-top-color: #de1b36;');
          ln[1].setAttribute('style', 'border-top-color: white;');
        }
        if (this.stepper.selectedIndex === 2) {
          ln[0].setAttribute('style', 'border-top-color: #de1b36;');
          ln[1].setAttribute('style', 'border-top-color: #de1b36;');
        }
      }
    } catch (e) {}
    try {
      const ln1 = document.getElementsByClassName(
        'mat-step-icon'
      ) as HTMLCollectionOf<HTMLElement>;
      if (ln1.length !== 0) {
        if (this.stepper.selectedIndex === 0) {
          ln1[0].setAttribute('style', 'background-color: #de1b36;');
          ln1[1].setAttribute('style', 'background-color: white;');
          ln1[2].setAttribute('style', 'background-color: white;');
          // ln1[1].setAttribute('style', 'border-top-color: white;');
        }
        if (this.stepper.selectedIndex === 1) {
          ln1[0].setAttribute('style', 'background-color: #de1b36;');
          ln1[1].setAttribute('style', 'background-color: #de1b36;');
          ln1[2].setAttribute('style', 'background-color: white;');
        }
        if (this.stepper.selectedIndex === 2) {
          ln1[0].setAttribute('style', 'background-color: #de1b36;');
          ln1[1].setAttribute('style', 'background-color: #de1b36;');
          ln1[2].setAttribute('style', 'background-color: #de1b36;');
        }
      }
    } catch (e) {}

    try {
      const ln2 = document.getElementsByClassName(
        'mat-horizontal-stepper-header'
      ) as HTMLCollectionOf<HTMLElement>;
      if (ln2.length !== 0) {
        if (this.stepper.selectedIndex === 0) {
          ln2[0].classList.remove('mat-horizontal-stepper-header-red');
          ln2[1].classList.remove('mat-horizontal-stepper-header-red');
          ln2[1].classList.remove('mat-horizontal-stepper-header-red-before');
          ln2[2].classList.remove('mat-horizontal-stepper-header-red');
        }
        if (this.stepper.selectedIndex === 1) {
          ln2[0].classList.add('mat-horizontal-stepper-header-red');
          ln2[1].classList.add('mat-horizontal-stepper-header-red-before');
          ln2[1].classList.remove('mat-horizontal-stepper-header-red');
          ln2[2].classList.remove('mat-horizontal-stepper-header-red');
        }
        if (this.stepper.selectedIndex === 2) {
          ln2[0].classList.add('mat-horizontal-stepper-header-red');
          ln2[1].classList.add('mat-horizontal-stepper-header-red');
          ln2[2].classList.add('mat-horizontal-stepper-header-red');
        }
      }
    } catch (e) {}

    if (this.stepper) {
      return this.stepper.selectedIndex;
    } else {
      return 0;
    }
  }

  private addCustomSVGIcons(): void {
    this.matIconRegistry.addSvgIcon(
      this.calendarIconRed,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/screening-party/calendar-icon-red.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      this.calendarIconWhite,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/screening-party/calendar-icon-white.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      this.filmIcon,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/screening-party/film-icon.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      this.partyIconRed,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/screening-party/party-icon-red.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      this.partyIconWhite,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/screening-party/party-icon-white.svg'
      )
    );
  }

  ngOnInit(): void {
    this.ngxSpinner.show();
    this.spotlightService.getData().subscribe(
      (response) => {
        this.spotlightList = response;
      },
      (error) => {
        console.log(error);
      }
    );

    this.showcaseService.getShowcases().subscribe(
      (response) => {
        const features = new Array(response.Features)
        const shorts = new Array(response.Shorts)

        this.showcaseList = features.concat(shorts);
        this.showcaseList = this.showcaseList[0].concat(this.showcaseList[1])
        this.showcaseList.sort((a, b) => a.name.localeCompare(b.name))
        this.ngxSpinner.hide();
      },
      (error) => {
        console.log(error);
        this.ngxSpinner.hide();
      }
    );
    this.isUpdate = this.screeningPartyService.getIsUpdate();
    if (!this.isUpdate) {
      this.setFirstFormGroup(undefined, 0, '');
      this.setSecondFormGroup('');
      this.setThirdFormGroup('', '', 50, '');
    } else {
      this.screeningPartyForUpdate =
        this.screeningPartyService.getScreeningParty();
      this.screeningPartyIdForUpdate =
        this.screeningPartyService.getScreeningPartyId();
      this.setFirstFormGroup(
        this.screeningPartyForUpdate.screeningPartyType,
        this.screeningPartyForUpdate.cinejoyFeaturedMovie,
        this.screeningPartyForUpdate.mobileNumber
      );
      this.setSecondFormGroup(this.screeningPartyForUpdate.meetingDateTime);
      this.setThirdFormGroup(
        this.screeningPartyForUpdate.meetingType,
        this.screeningPartyForUpdate.meetingLink,
        this.screeningPartyForUpdate.meetingCapacity,
        this.screeningPartyForUpdate.description
      );
    }
  }

  getEnumKeyByEnumValue(myEnum, enumValue): any {
    const keys = Object.keys(myEnum).filter((x) => myEnum[x] === enumValue);
    return keys.length > 0 ? keys[0] : null;
  }

  private setFirstFormGroup(
    screeningPartyType: ScreeningPartyType,
    cinejoyFeaturedMovie: number,
    mobileNumber: string
  ): void {
    this.firstFormGroup = this.formBuilder.group({
      screeningPartyType: [
        this.getEnumKeyByEnumValue(ScreeningPartyType, screeningPartyType),
        Validators.required,
      ],
      cinejoyFeaturedMovie: [cinejoyFeaturedMovie, Validators.required],
      mobileNumber: [mobileNumber, Validators.required],
    });
  }

  private setSecondFormGroup(meetinDateTime: string): void {
    this.secondFormGroup = this.formBuilder.group({
      meetingDateTime: [meetinDateTime, Validators.required],
    });
  }

  private setThirdFormGroup(
    meetingType: string,
    meetingLink: string,
    meetingCapacity: number,
    description: string
  ): void {
    this.thirdFormGroup = this.formBuilder.group({
      meetingType: [
        this.getEnumKeyByEnumValue(MeetingType, meetingType),
        Validators.required,
      ],
      meetingLink: [meetingLink, Validators.required],
      meetingCapacity: [meetingCapacity, Validators.required],
      description: [description],
    });
  }

  getCurrentDate(): string {
    return this.datepipe.transform(
      new Date().toISOString(),
      'YYYY-MM-ddThh:mm'
    );
  }

  isFieldError(): boolean {
    return this.firstFormGroup.controls.cinejoyFeaturedMovie.hasError(
      'required'
    );
  }

  validateForm(): boolean {
    return (
      this.firstFormGroup.valid &&
      this.secondFormGroup.valid &&
      this.thirdFormGroup.valid
    );
  }

  submitScreeningParty(): void {
    if (this.validateForm()) {
      const screeningParty = {
        ...this.firstFormGroup.value,
        ...this.secondFormGroup.value,
        ...this.thirdFormGroup.value,
      };
      this.ngxSpinner.show();
      screeningParty.meetingDateTime = new Date(screeningParty.meetingDateTime);
      screeningParty.meetingLocalDateTime = screeningParty.meetingDateTime;
      if (!this.isUpdate) {
        this.screeningPartyService
          .createScreeningParty(screeningParty)
          .subscribe(
            (response) => {
              this.screeningPartyService.resetScreeningParty();
              this.exportScreeningParty(response, false);
            },
            (error) => {
              console.error(error);
              this.ngxSpinner.hide();
            }
          );
      } else {
        this.screeningPartyService
          .updateScreeningParty(this.screeningPartyIdForUpdate, screeningParty)
          .subscribe(
            (response) => {
              this.screeningPartyService.resetScreeningParty();
              this.exportScreeningParty(response, true);
            },
            (error) => {
              console.error(error);
              this.ngxSpinner.hide();
            }
          );
      }
    }
  }

  exportScreeningParty(screeningPartyResponse: any, isEdit: boolean): void {
    this.screeningPartyService
      .exportScreeningPartyInvitation(screeningPartyResponse.id, isEdit)
      .subscribe(
        (response) => {
          // this.router.navigate(['/cinejoy/screening-party/export/invitation/' + screeningPartyResponse.id]);
          this.isInvitation = true;
          this.invitationScreeningPartyId = screeningPartyResponse.id;
          this.ngxSpinner.hide();
        },
        (error) => {
          console.log(error);
          this.ngxSpinner.hide();
        }
      );
  }

  goToPreviousStep(): void {
    this.validateForm();
    if (this.currentStep > 1) {
    }
    {
      this.currentStep--;
    }
  }

  updateMovieList(event: any): void {
    this.firstFormGroup.controls.cinejoyFeaturedMovie.reset();
  }

  isSpotlightSelected(): boolean {
    if (this.firstFormGroup.controls.screeningPartyType.value === 'SPOTLIGHT') {
      return true;
    }
    return false;
  }

  isShowcaseSelected(): boolean {
    // tslint:disable-next-line:no-string-literal
    if (this.firstFormGroup.controls.screeningPartyType.value === 'SHOWCASE') {
      return true;
    }
    return false;
  }
}
